/* eslint-disable prettier/prettier */
import { axiosTDMS } from "./axiosInstance";

export default {
    // eslint-disable-next-line prettier/prettier
    uploadFile: async function (formdata) {
        return axiosTDMS.post("tdms/UploadFileToS3", formdata);
    }

};